import axios from 'axios';
import { API_URL } from 'src/config/api';

//import jwt_decode from 'jwt-decode';
import { IConfiguracionesAtributtes } from 'src/models/Configuraciones';
const urls = API_URL + 'configuraciones';

export const getConfiguraciones = () => {
  const token = sessionStorage.getItem('tokenDelta');

  const siteConfigString = sessionStorage.getItem('delta_siteConfig');
  const tsString = sessionStorage.getItem('delta_siteConfig_ts');

  const MAX_AGE_MS = 10 * 60 * 1000; // 10 min
  const ts = tsString ? Number(tsString) : 0;
  const isFresh = siteConfigString && ts && Date.now() - ts < MAX_AGE_MS;

  if (isFresh) {
    try {
      const siteConfig: IConfiguracionesAtributtes = JSON.parse(
        siteConfigString!
      );
      return siteConfig;
    } catch (error) {
      // si está corrupto, forzá fetch
      sessionStorage.removeItem('delta_siteConfig');
      sessionStorage.removeItem('delta_siteConfig_ts');
    }
  } else {
    // expiró o no hay ts: forzá fetch
    sessionStorage.removeItem('delta_siteConfig');
    sessionStorage.removeItem('delta_siteConfig_ts');
  }

  return axios
    .get<IConfiguracionesAtributtes>(urls, { headers: { 'auth-token': token } })
    .then((response) => {
      sessionStorage.setItem('delta_siteConfig', JSON.stringify(response.data));
      sessionStorage.setItem('delta_siteConfig_ts', String(Date.now()));
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      if (error.response.status == 404 || error.response.status == 401) {
        return error;
      }
    })
    .catch(function (error) {
      console.log(error);

      alert('Error de conexión, comunicarse con soporte');
    });
};
export const postConfiguraciones = (params: IConfiguracionesAtributtes) => {
  const token = sessionStorage.getItem('tokenDelta');

  const dataMeta = window.sessionStorage.getItem('_clientMeta');
  const dataMetaua = window.sessionStorage.getItem('_clientUA');
  const dataMetaav = window.sessionStorage.getItem('_clientAV');

  return axios
    .post<IConfiguracionesAtributtes>(urls, params as any, {
      headers: {
        'auth-token': token,
        _clientMeta: dataMeta,
        _clientUA: dataMetaua,
        _clientAV: dataMetaav
      }
    })
    .then((response) => {
      window.sessionStorage.setItem('delta_siteConfig', JSON.stringify(params));
      return response.data;
    })
    .catch(function (error) {
      console.log(error);
      if (error.response.status == 404) {
        alert('Error: ' + JSON.stringify(error));
        return;
      }
    })
    .catch(function (error) {
      console.log(error);

      alert('Error: ' + JSON.stringify(error));
    });
};
